/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_1_TitleInputs */

const en_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 Iowa Open Champion`)
};

const es_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeón del Iowa Open 1990`)
};

const de_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieger der Iowa Open 1990`)
};

const zh_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 年 Iowa Open 冠军`)
};

const ar_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطل Iowa Open لعام 1990`)
};

const fr_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champion de l’Iowa Open 1990`)
};

const vi_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch Iowa Open 1990`)
};

const sw_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bingwa wa Iowa Open 1990`)
};

const th_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์ Iowa Open ปี 1990`)
};

const bs_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion Iowa Open 1990.`)
};

const ja_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990年 Iowa Open 優勝`)
};

const ko_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 Iowa Open 챔피언`)
};

const pt_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeão do Iowa Open de 1990`)
};

const it_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione dell’Iowa Open 1990`)
};

const sv_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mästare i Iowa Open 1990`)
};

const nl_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioen Iowa Open 1990`)
};

const da_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mester i Iowa Open 1990`)
};

const nb_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mester i Iowa Open 1990`)
};

const fi_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Openin mestari 1990`)
};

const pl_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrz Iowa Open 1990`)
};

const ru_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпион Iowa Open 1990 года`)
};

const tr_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 Iowa Open şampiyonu`)
};

const hi_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 Iowa Open चैंपियन`)
};

const id_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa Open 1990`)
};

const ms_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa Open 1990`)
};

const cs_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion Iowa Open 1990`)
};

const el_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητής του Iowa Open 1990`)
};

const he_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלוף Iowa Open לשנת 1990`)
};

const af_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1990 Iowa Open-kampioen`)
};

const hu_about_content_competitive_1_title = /** @type {(inputs: About_Content_Competitive_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az 1990-es Iowa Open bajnoka`)
};

/**
* | output |
* | --- |
* | "1990 Iowa Open Champion" |
*
* @param {About_Content_Competitive_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_1_title = /** @type {((inputs?: About_Content_Competitive_1_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_1_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_1_title(inputs)
	if (locale === "de") return de_about_content_competitive_1_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_1_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_1_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_1_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_1_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_1_title(inputs)
	if (locale === "th") return th_about_content_competitive_1_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_1_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_1_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_1_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_1_title(inputs)
	if (locale === "it") return it_about_content_competitive_1_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_1_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_1_title(inputs)
	if (locale === "da") return da_about_content_competitive_1_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_1_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_1_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_1_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_1_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_1_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_1_title(inputs)
	if (locale === "id") return id_about_content_competitive_1_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_1_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_1_title(inputs)
	if (locale === "el") return el_about_content_competitive_1_title(inputs)
	if (locale === "he") return he_about_content_competitive_1_title(inputs)
	if (locale === "af") return af_about_content_competitive_1_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_1_title(inputs)
	return en_about_content_competitive_1_title(inputs)
});